import React, { useEffect } from 'react';

import Input from 'components/input';
import Button from 'components/button';
import Selection from 'components/select';
import {
  jobStatuses,
  availability,
  getFilterCount,
  employmentTypes,
  applicationStatuses,
} from './helper';

import cross from 'assets/Close.svg';

import style from './filter.module.scss';

const Filters = ({
  watch,
  reset,
  setValue,
  register,
  btnLoader,
  openFilter,
  setBtnLoader,
  isSubmitting,
  handleSubmit,
  setOpenFilter,
  setFilterCount,
  getApplications,
}) => {
  useEffect(() => {
    const count = getFilterCount(watch);
    setValue('filterCount', count);
  }, [watch()]);

  return (
    <>
      <div className={style.filter}>
        <div className={style.filterHeader}>
          <h1>Filters</h1>
          <img src={cross} alt="" onClick={() => setOpenFilter(false)} />
        </div>
        <form onSubmit={handleSubmit(getApplications)}>
          <div className={style.body}>
            <div className={style.inner}>
              <div>
                <Selection
                  id="Select"
                  name="jobStatus"
                  label="Job Status"
                  setValue={setValue}
                  placeholder="Select"
                  options={jobStatuses}
                  value={watch('jobStatus')}
                />
              </div>
              <div>
                <Selection
                  id="Select"
                  setValue={setValue}
                  placeholder="Select"
                  name="applicationStatus"
                  label="Application Status"
                  options={applicationStatuses}
                  value={watch('applicationStatus')}
                />
              </div>
              <div>
                <Selection
                  id="Select"
                  setValue={setValue}
                  placeholder="Select"
                  name="employmentType"
                  label="Employment Type"
                  options={employmentTypes}
                  value={watch('employmentType')}
                />
              </div>
              <div>
                <Selection
                  id="Select"
                  name="availability"
                  setValue={setValue}
                  placeholder="Select"
                  label={'Availability'}
                  options={availability}
                  value={watch('availability')}
                />
              </div>
              <div>
                <Input
                  type={'date'}
                  name="postedDate"
                  register={register}
                  label={'Job Posted Date'}
                />
              </div>
              <div>
                <Input
                  type={'date'}
                  name="dateApplied"
                  register={register}
                  label={'Applied Date'}
                />
              </div>
            </div>
            <div className={style.btnDiv}>
              <Button
                text={'Reset'}
                type={'button'}
                btnClass={style.btn}
                isLoading={btnLoader}
                loaderClass={style.loaderClass}
                handleClick={() => {
                  setFilterCount();
                  setBtnLoader(true);
                  reset();
                  setValue('status', null);
                  setValue('location', null);
                  setValue('availability', null);
                  getApplications();
                }}
              />
              <Button
                text={'Apply'}
                type={'submit'}
                isLoading={isSubmitting}
                handleClick={() => setFilterCount(watch('filterCount'))}
              />
            </div>
          </div>
        </form>
      </div>
      {openFilter && (
        <div className={style.backdrop} onClick={() => setOpenFilter(false)} />
      )}
    </>
  );
};

export default Filters;
